import gsap from "gsap";

export default class Fade {
    constructor(el) {
        this.el = el;


        gsap.to(this.el, {
            opacity: 1,
            y: 0,
            x: 0,
            duration: 0.7,
        });
    }
}